import { render, staticRenderFns } from "./s02-key-dates.vue?vue&type=template&id=c2dd991a&scoped=true"
import script from "./s02-key-dates.vue?vue&type=script&lang=js"
export * from "./s02-key-dates.vue?vue&type=script&lang=js"
import style0 from "./s02-key-dates.vue?vue&type=style&index=0&id=c2dd991a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd991a",
  null
  
)

export default component.exports